<form [formGroup]="timeCtrlGroup">
  <ng-container *ngIf="isTableCell">
    <div class="input-container">
      {{ 'hour.plural' | translate }}
      <input type="number" placeholder="hh" formControlName="hours">
    </div>

    <div class="input-container">
      {{ 'minute.plural' | translate }}
      <input type="number" placeholder="mm" formControlName="minutes">
    </div>

    <div class="input-container">
      {{ 'second.plural' | translate }}
      <input type="text" placeholder="ss" formControlName="seconds" #secondsInput numbersOnly [allowDecimals]="false">
    </div>
  </ng-container>

  <div *ngIf="!isTableCell" class="ion-input-container" [class.focused]="ionInputIsFocused">
      <ion-input
        (ionFocus)="onIonInputFocus()"
        (ionBlur)="onIonInputBlur()"
        labelPlacement="floating"
        [label]="'hh' | translate"
        autocomplete="off"
        type="number"
        formControlName="hours"></ion-input>

      <ion-input
        (ionFocus)="onIonInputFocus()"
        (ionBlur)="onIonInputBlur()"
        labelPlacement="floating"
        [label]="'mm' | translate"
        autocomplete="off"
        type="number"
        formControlName="minutes"></ion-input>
      <ion-input
        (ionFocus)="onIonInputFocus()"
        (ionBlur)="onIonInputBlur()"
        labelPlacement="floating"
        [label]="'ss' | translate"
        autocomplete="off"
        type="number"
        formControlName="seconds"></ion-input>

  </div>
</form>
